
(function () {
  'use strict';
  if (window.AuziOffer) return;

  var copyElement = document.getElementById('auzi-offer-copy');
  var offerCopy = copyElement ? JSON.parse(copyElement.textContent) : {};
  function offerText(key, value) { return (offerCopy[key] || '').replace(/{{\s*value\s*}}/g, value); }
  var STORAGE_KEY = 'auzi_active_offer_v1';
  var PENDING_KEY = 'auzi_offer_pending_activation';
  var cartApplyRequest = null;
  var cartApplyCode = '';
  var knownOffers = {
    'GLOW10A': { code: 'GLOW10A', label: '10% reward', type: 'percentage', value: 10, scope: 'all', source: 'quiz' },
    'GOLD15Y': { code: 'GOLD15Y', label: '15% reward', type: 'percentage', value: 15, scope: 'all', source: 'quiz' },
    'SHINE20X': { code: 'SHINE20X', label: '20% reward', type: 'percentage', value: 20, scope: 'all', source: 'quiz' },
    'BESPOKE50': { code: 'BESPOKE50', label: '£50 credit', type: 'fixed_order', value: 50, currency: 'GBP', scope: 'all', source: 'quiz' }
  };

  function safeJson(value, fallback) {
    try { return JSON.parse(value); } catch (e) { return fallback; }
  }

  function normalizeCode(code) {
    return String(code || '').trim();
  }

  function knownOffer(code) {
    var clean = normalizeCode(code).toUpperCase();
    var match = knownOffers[clean];
    return match ? Object.assign({}, match) : null;
  }

  function normalizeOffer(raw) {
    raw = raw || {};
    var code = normalizeCode(raw.code);
    if (!code) return null;
    var known = knownOffer(code);
    var offer = Object.assign({}, known || {}, raw);
    offer.code = code;
    offer.type = String(offer.type || 'unknown');
    offer.scope = String(offer.scope || 'unknown');
    offer.value = Number(offer.value || 0);
    offer.label = String(offer.label || (offer.type === 'percentage' && offer.value ? offerText('percent', offer.value) : 'Offer active'));
    offer.source = String(offer.source || 'link');
    offer.currency = String(offer.currency || '');
    offer.products = Array.isArray(offer.products) ? offer.products.filter(Boolean) : [];
    offer.activatedAt = Number(offer.activatedAt || Date.now());
    return offer;
  }

  function get() {
    try {
      var value = safeJson(localStorage.getItem(STORAGE_KEY), null);
      return normalizeOffer(value);
    } catch (e) {
      return null;
    }
  }

  function store(offer) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(offer)); } catch (e) {}
  }

  function clear(options) {
    options = options || {};
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    renderHeader(null);
    document.querySelectorAll('[data-auzi-price-root], [data-auzi-card-price]').forEach(function (root) {
      clearRenderedOffer(root);
    });
    document.documentElement.classList.remove('auzi-offer-is-active');
    if (options.dispatch !== false) {
      window.dispatchEvent(new CustomEvent('auzi:offer:cleared'));
    }
  }

  function routeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/');
  }

  function applyToCart(offer) {
    if (!offer || !offer.code) return Promise.resolve(null);
    // Reuse an in-flight update so page and cart events cannot race one another.
    if (cartApplyRequest && cartApplyCode === offer.code) return cartApplyRequest;
    cartApplyCode = offer.code;
    var request = (async function () {
      try {
        var response = await fetch(routeRoot() + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: offer.code })
        });
        if (!response.ok) return null;
        return await response.json();
      } catch (e) {
        return null;
      }
    })();
    cartApplyRequest = request;
    request.finally(function () {
      if (cartApplyRequest === request) {
        cartApplyRequest = null;
        cartApplyCode = '';
      }
    });
    return request;
  }

  function currencyFor(root) {
    return (root && root.dataset.auziCurrency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'GBP';
  }

  function formatMoney(cents, currency) {
    var minor = Number(cents || 0);
    var unit = String(currency || 'GBP').toUpperCase();
    var zeroDecimal = /^(JPY|KRW|VND|CLP|ISK)$/.test(unit);
    // Keep pence/cents where needed. A £82.00 product at 10% off is
    // £73.80, never the rounded-to-£74 approximation.
    var fraction = zeroDecimal || minor % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: unit,
        minimumFractionDigits: fraction,
        maximumFractionDigits: fraction
      }).format(minor / 100);
    } catch (e) {
      return '£' + (minor / 100).toFixed(2).replace(/\.00$/, '');
    }
  }

  function offerSavingsLabel(offer) {
    var percent = String(Number(offer.value) || 0);
    var locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var quiz = offer.source === 'quiz';
    var labels = {
      en: quiz ? '{n}% quiz reward applied' : '{n}% discount applied',
      fr: quiz ? 'Récompense quiz de {n} % appliquée' : 'Réduction de {n} % appliquée',
      de: quiz ? '{n} % Quiz-Rabatt angewendet' : '{n} % Rabatt angewendet',
      es: quiz ? 'Descuento del quiz del {n} % aplicado' : 'Descuento del {n} % aplicado',
      it: quiz ? 'Sconto quiz del {n}% applicato' : 'Sconto del {n}% applicato',
      nl: quiz ? '{n}% quizkorting toegepast' : '{n}% korting toegepast',
      pt: quiz ? 'Desconto de {n}% do quiz aplicado' : 'Desconto de {n}% aplicado',
      ar: quiz ? 'تم تطبيق خصم الاختبار {n}٪' : 'تم تطبيق خصم {n}٪',
      ja: quiz ? 'クイズ特典 {n}% 適用済み' : '{n}% 割引適用済み',
      ko: quiz ? '퀴즈 할인 {n}% 적용됨' : '{n}% 할인 적용됨',
      tr: quiz ? '%{n} test indirimi uygulandı' : '%{n} indirim uygulandı'
    };
    return (labels[locale] || labels.en).replace('{n}', percent);
  }

  function isEligible(root, offer) {
    if (!root || !offer) return false;
    // Sold-out products and unavailable variants show the normal price and
    // availability badge, never an applied-offer price or savings message.
    if (root.classList.contains('price--sold-out') || root.dataset.auziAvailable === 'false') return false;
    // Shopify does not discount the purchase of gift cards.
    var handle = String(root.dataset.auziProductHandle || '').toLowerCase();
    if (/gift[-_]?cards?/.test(handle)) return false;
    if (offer.scope === 'all') return true;
    if (offer.scope === 'products' && offer.products.length) {
      return offer.products.indexOf(root.dataset.auziProductHandle || '') !== -1;
    }
    return false;
  }

  function clearRenderedOffer(root) {
    root.classList.remove('auzi-offer-price-active');
    delete root.dataset.auziOfferRendered;
    var existing = root.querySelector('.auzi-offer-price-stack, .auzi-offer-price-row');
    if (existing) existing.remove();
    var note = root.querySelector('.auzi-offer-price-note');
    if (note) note.remove();
  }

  function renderPrice(root, offer) {
    if (!root) return;
    var active = offer && isEligible(root, offer);
    var base = Number(root.dataset.auziBasePriceCents || 0);
    if (!active || !(base > 0)) {
      if (root.classList.contains('auzi-offer-price-active') ||
          root.querySelector('.auzi-offer-price-stack, .auzi-offer-price-note')) {
        clearRenderedOffer(root);
      }
      return;
    }
    var currency = currencyFor(root);
    var key = [offer.code, offer.type, offer.value, offer.scope, base, currency].join('|');
    // Avoid updating identical DOM repeatedly; a child-list observer watches
    // dynamic Shopify sections and repeated writes would trigger a render loop.
    if (root.dataset.auziOfferRendered === key) return;
    clearRenderedOffer(root);

    if (offer.type === 'percentage' && offer.value > 0 && offer.value < 100) {
      var discounted = Math.max(0, Math.round(base * (1 - offer.value / 100)));
      var stack = document.createElement('span');
      stack.className = 'auzi-offer-price-stack';
      var row = document.createElement('span');
      row.className = 'auzi-offer-price-row';
      var current = document.createElement('span');
      current.className = 'price-item price-item--regular auzi-offer-price-current';
      current.textContent = formatMoney(discounted, currency);
      var note = document.createElement('small');
      note.className = 'auzi-offer-price-note';
      note.textContent = offerSavingsLabel(offer);
      row.appendChild(current);
      stack.appendChild(row);
      stack.appendChild(note);
      // Keep the discounted price ahead of availability badges on all product pages.
      // Previously appending after the badges made "Sold out" appear before the price.
      var firstBadge = root.querySelector(':scope > .price__badge-sale, :scope > .price__badge-sold-out');
      root.insertBefore(stack, firstBadge || null);
      root.classList.add('auzi-offer-price-active');
      root.dataset.auziOfferRendered = key;
      return;
    }

    if (offer.type === 'fixed_order' && offer.value > 0) {
      // A cart-level credit is not an item discount: keep the actual item
      // price and say where the credit applies.
      var note = document.createElement('small');
      note.className = 'auzi-offer-price-note auzi-offer-price-note--credit';
      var fixedCents = Math.round(offer.value * 100);
      note.textContent = offerText('credit', formatMoney(fixedCents, offer.currency || currency)) + ' · ' + offerCopy.checkout;
      root.appendChild(note);
      root.dataset.auziOfferRendered = key;
    }
  }

  function renderHeader(offer) {
    document.querySelectorAll('[data-auzi-offer-chip]').forEach(function (chip) {
      if (!offer) {
        chip.setAttribute('aria-hidden', 'true');
        return;
      }
      var label = chip.querySelector('[data-auzi-offer-label]');
      var button = chip.querySelector('[data-auzi-offer-button]');
      var appliedLabel = offer.label;
      if (offer.type === 'percentage' && offer.value) {
        appliedLabel = offer.value + '% off applied';
      } else if (offer.type === 'fixed_order' && offer.value) {
        if (offer.label && offer.label !== 'Offer active' && offer.label !== 'Credit active') {
          appliedLabel = offer.label.replace(/\s+applied$/i, '') + ' applied';
        } else {
          var creditCurrency = offer.currency || ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP');
          try {
            appliedLabel = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
              style: 'currency',
              currency: creditCurrency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(offer.value) + ' credit applied';
          } catch (e) {
            appliedLabel = offer.value + ' credit applied';
          }
        }
      } else {
        appliedLabel = 'Offer applied';
      }
      if (label) label.textContent = appliedLabel;
      if (button) {
        button.dataset.auziOfferCode = offer.code;
        button.title = offer.code ? appliedLabel + ' · ' + offer.code + ' · click to copy code' : appliedLabel;
      }
      chip.setAttribute('aria-hidden', 'false');
    });
  }

  var isRefreshing = false;

  function refresh() {
    if (isRefreshing) return get();
    isRefreshing = true;
    var offer = get();
    renderHeader(offer);
    document.querySelectorAll('[data-auzi-price-root], [data-auzi-card-price]').forEach(function (root) {
      renderPrice(root, offer);
    });
    document.documentElement.classList.toggle('auzi-offer-is-active', !!offer);
    window.requestAnimationFrame(function () { isRefreshing = false; });
    return offer;
  }

  function activate(raw, options) {
    var offer = normalizeOffer(raw);
    if (!offer) return null;
    options = options || {};
    store(offer);
    refresh();
    if (options.applyToCart !== false) applyToCart(offer);
    window.dispatchEvent(new CustomEvent('auzi:offer:activated', { detail: offer }));
    return offer;
  }

  function reapplyQuizOffer() {
    var offer = get();
    if (!offer || offer.source !== 'quiz') return Promise.resolve(null);
    // A reward won before there were products in the cart may not yet have
    // an applicable discount. Reapply immediately after the first add.
    return applyToCart(offer).then(function (cart) {
      if (cart && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auzi-offer' });
      }
      refresh();
      return cart;
    });
  }

  function parseUrlOffer() {
    var params = new URLSearchParams(window.location.search);
    var explicit = params.get('auzi_offer') || params.get('auzi_offer_code');
    var general = params.get('discount') || params.get('voucher');
    var code = explicit || general;
    if (!code) return null;

    var base = knownOffer(code) || { code: code, label: 'Offer active', type: 'unknown', scope: 'unknown', source: 'link' };
    var type = params.get('auzi_offer_type');
    var value = params.get('auzi_offer_value');
    var label = params.get('auzi_offer_label');
    var currency = params.get('auzi_offer_currency');
    var scope = params.get('auzi_offer_scope');
    var products = params.get('auzi_offer_products');

    if (type) base.type = type;
    if (value !== null && value !== '') base.value = Number(value);
    if (label) base.label = label;
    if (currency) base.currency = currency.toUpperCase();
    if (scope) base.scope = scope;
    if (products) base.products = products.split(',').map(function (x) { return x.trim(); }).filter(Boolean);

    var offer = activate(base, { applyToCart: true });

    if (explicit || params.has('auzi_offer_type') || params.has('auzi_offer_value') || params.has('auzi_offer_label') || params.has('auzi_offer_scope') || params.has('auzi_offer_products')) {
      ['auzi_offer','auzi_offer_code','auzi_offer_type','auzi_offer_value','auzi_offer_label','auzi_offer_currency','auzi_offer_scope','auzi_offer_products'].forEach(function (key) {
        params.delete(key);
      });
      var clean = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
      window.history.replaceState({}, '', clean);
    }
    return offer;
  }

  async function syncFromCart() {
    try {
      // A newly won reward might still be updating the Shopify cart.
      if (cartApplyRequest) await cartApplyRequest;
      var currentOffer = get();
      var applicableCodes = [];
      var actions = window.Shopify && window.Shopify.actions;

      if (actions && typeof actions.getCart === 'function') {
        try {
          var actionCart = await actions.getCart();
          applicableCodes = ((actionCart && actionCart.cart && actionCart.cart.discountCodes) || [])
            .filter(function (item) { return item && item.applicable && item.code; })
            .map(function (item) { return String(item.code); });
        } catch (e) {}
      }

      var ajaxCart = null;
      try {
        var response = await fetch(routeRoot() + 'cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' },
          cache: 'no-store'
        });
        if (response.ok) ajaxCart = await response.json();
      } catch (e) {}

      var applications = [];
      if (ajaxCart) {
        (ajaxCart.cart_level_discount_applications || []).forEach(function (app) {
          if (app) applications.push(app);
        });
        (ajaxCart.items || []).forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (allocation) {
            if (allocation && allocation.discount_application) applications.push(allocation.discount_application);
          });
        });

        applications.forEach(function (app) {
          var title = String(app && app.title || '').trim();
          if (title && applicableCodes.indexOf(title) === -1) applicableCodes.push(title);
        });
      }

      applicableCodes = applicableCodes.filter(Boolean);
      // Re-read after the awaits: a quiz reward can be activated while an
      // earlier, empty-cart check is still resolving.
      currentOffer = get();

      if (!applicableCodes.length) {
        // Cart APIs can return no applicable discounts on an empty cart or
        // during add-to-cart. A claimed quiz reward must survive navigation.
        // Explicit removal via the cart's remove button still calls clear().
        if (currentOffer && currentOffer.source === 'quiz') {
          renderHeader(currentOffer);
          return currentOffer;
        }
        clear();
        return null;
      }

      // Ajax cart discount applications sometimes expose Shopify's human-
      // readable discount title, not the redeemable code. Do not replace
      // a known quiz prize with an unrecognised title in the header pill.
      if (currentOffer && currentOffer.source === 'quiz') {
        var otherKnownCode = applicableCodes.some(function (code) {
          var known = knownOffer(code);
          return known && known.code.toLowerCase() !== currentOffer.code.toLowerCase();
        });
        var prizeConfirmed = applicableCodes.some(function (code) {
          return code.toLowerCase() === currentOffer.code.toLowerCase();
        });
        if (!otherKnownCode && !prizeConfirmed) {
          renderHeader(currentOffer);
          return currentOffer;
        }
      }

      var activeCode = applicableCodes[0];
      var matched = knownOffer(activeCode);

      if (matched) {
        return activate(matched, { applyToCart: false });
      }

      if (currentOffer && currentOffer.code && applicableCodes.some(function (code) {
        return code.toLowerCase() === currentOffer.code.toLowerCase();
      })) {
        return activate(currentOffer, { applyToCart: false });
      }

      var app = applications.find(function (item) {
        return item && String(item.title || '').toLowerCase() === activeCode.toLowerCase();
      }) || applications[0];

      var synced = {
        code: activeCode,
        label: 'Offer active',
        type: 'unknown',
        value: 0,
        scope: app && app.target_selection === 'all' ? 'all' : 'unknown',
        source: 'cart'
      };

      if (app && app.value_type === 'percentage') {
        synced.type = 'percentage';
        synced.value = Number(app.value || 0);
        synced.label = synced.value ? synced.value + '% off' : 'Offer active';
      } else if (app && app.value_type === 'fixed_amount') {
        synced.type = 'fixed_order';
        synced.value = Number(app.value || 0);
        synced.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        synced.label = synced.value ? 'Credit active' : 'Offer active';
      }

      return activate(synced, { applyToCart: false });
    } catch (e) {
      return null;
    }
  }

  function rememberDiscountLink(anchor) {
    if (!anchor || !anchor.href) return;
    try {
      var url = new URL(anchor.href, window.location.origin);
      var match = url.pathname.match(/\/discount\/([^/?#]+)/i);
      if (!match) return;
      var code = decodeURIComponent(match[1]);
      var base = knownOffer(code) || {
        code: code,
        label: anchor.dataset.auziOfferLabel || 'Offer active',
        type: anchor.dataset.auziOfferType || 'unknown',
        value: Number(anchor.dataset.auziOfferValue || 0),
        scope: anchor.dataset.auziOfferScope || 'unknown',
        products: (anchor.dataset.auziOfferProducts || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean),
        source: 'discount-link'
      };
      activate(base, { applyToCart: false });
    } catch (e) {}
  }

  function copyOfferCode(button) {
    var code = button && button.dataset.auziOfferCode;
    if (!code) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code);
    } catch (e) {}
    var chip = button.closest('[data-auzi-offer-chip]');
    var toast = chip && chip.querySelector('[data-auzi-offer-toast]');
    if (toast) {
      toast.textContent = offerCopy.copied + ' · ' + code;
      toast.classList.add('is-visible');
      window.setTimeout(function () { toast.classList.remove('is-visible'); }, 1800);
    }
  }

  document.addEventListener('click', function (event) {
    var offerButton = event.target.closest('[data-auzi-offer-button]');
    if (offerButton) {
      event.preventDefault();
      copyOfferCode(offerButton);
      return;
    }

    var discountLink = event.target.closest('a[href*="/discount/"]');
    if (discountLink) rememberDiscountLink(discountLink);

    var checkout = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    var active = get();
    if (checkout && active && active.code && !checkout.dataset.auziOfferPassingThrough) {
      event.preventDefault();
      checkout.dataset.auziOfferPassingThrough = '1';
      applyToCart(active).finally(function () {
        if (checkout.tagName === 'A' && checkout.href) {
          window.location.href = checkout.href;
        } else {
          var form = checkout.closest('form');
          if (form) {
            var hidden = form.querySelector('input[name="checkout"]');
            if (!hidden && checkout.name === 'checkout') {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'checkout';
              hidden.value = 'Checkout';
              form.appendChild(hidden);
            }
            form.submit();
          } else {
            window.location.href = routeRoot() + 'checkout';
          }
        }
      });
    }
  });

  var refreshTimer;
  var observer = new MutationObserver(function () {
    if (isRefreshing) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 60);
  });

  function init() {
    var pending = safeJson(localStorage.getItem(PENDING_KEY), null);
    if (pending) {
      try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
      activate(pending, { applyToCart: true });
    } else {
      var linkedOffer = parseUrlOffer();
      if (!linkedOffer) {
        // Keep the earned offer pill visible immediately on product pages.
        refresh();
        syncFromCart();
      }
    }
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }

  window.AuziOffer = {
    activate: activate,
    clear: clear,
    get: get,
    refresh: refresh,
    sync: syncFromCart,
    applyToCart: function () { return applyToCart(get()); },
    knownOffer: knownOffer
  };

  document.addEventListener('auzi:card-price-change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('auzi:cart-rendered', function () {
    reapplyQuizOffer().then(syncFromCart);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'auzi-offer') return;
      reapplyQuizOffer();
    });
  }
  window.addEventListener('pageshow', syncFromCart);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

